import { render, staticRenderFns } from "./IconListItem.vue?vue&type=template&id=10b0c9a4&scoped=true&"
import script from "./IconListItem.vue?vue&type=script&lang=js&"
export * from "./IconListItem.vue?vue&type=script&lang=js&"
import style0 from "./IconListItem.vue?vue&type=style&index=0&id=10b0c9a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b0c9a4",
  null
  
)

export default component.exports